<template>
  <section class="section">
    <h1 v-if="title" class="title">{{ title }}</h1>
    <div v-if="description" class="description">{{ description }}</div>
    <slot name="descSlot" />
    <div class="content">
      <slot />
    </div>
  </section>
</template>

<script>
/**
 * セクション
 */
export default {
  name: 'Section',
  props: {
    /** タイトル */
    title: String,
    /** 説明 */
    description: String,
  },
}
</script>

<style lang="postcss" scoped>
.section {
  display: grid;
  grid-gap: 8px;
}

.title {
  font-size: 15px;
  font-weight: 600;
  line-height: 1;
}

.description {
  font-size: 13px;
  white-space: pre-line;
}

.content {
  background: var(--white);
  display: grid;
  grid-gap: 16px;
  overflow: auto;
  padding: 16px;
}
</style>
